<template>
  <card>
    <div class="container">
      <div style="margin: 10px 10px 10px 10px">
        <el-row>
          <el-col :span="18">
            <el-button type="warning" @click="add()"
              >新增設定</el-button
            >
          </el-col>
          <!-- <el-col :span="6">
            <el-input
              placeholder="Search"
              v-model="filters[0].value"
            ></el-input>
          </el-col> -->
        </el-row>
      </div>

      <!-- order limit table -->
      <data-tables
        :data="tableData"
        :pagination-props="{ pageSizes: [15, 25, 50] }"
        :filters="filters"
        :table-props="tableProps"
      >
        <el-table-column
          label="取餐方式"
          prop="mealType"
          sortable="custom"
          min-width="30px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.mealType=='eat_in'">內用</span>
            <span v-else-if="scope.row.mealType=='to_go'">自取</span>
            <span v-else>外送</span>
          </template>
        </el-table-column>
        <el-table-column
          label="營業時間"
          prop="periodSession"
          sortable="custom"
          min-width="30px"
        >
          <template slot-scope="scope">
            <span v-for="(p, index) in scope.row.periodSession" :key="index">
              <span v-if="p==0">週日</span>
              <span v-if="p==1">週一</span>
              <span v-if="p==2">週二</span>
              <span v-if="p==3">週三</span>
              <span v-if="p==4">週四</span>
              <span v-if="p==5">週五</span>
              <span v-if="p==6">週六</span>
              <span v-if="index !== scope.row.periodSession.length - 1">、</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="開始時間"
          prop="timeSessionStart"
          sortable="custom"
          min-width="30px"
        >
          <template slot-scope="scope">{{
            scope.row.timeSessionStart
          }}</template>
        </el-table-column>
        <el-table-column
          label="結束時間"
          prop="timeSessionEnd"
          sortable="custom"
          min-width="30px"
        >
          <template slot-scope="scope">{{ scope.row.timeSessionEnd }}</template>
        </el-table-column>
        <el-table-column
          label="間隔時段(分鐘)"
          prop="sessionTime"
          sortable="custom"
          min-width="30px"
        >
          <template slot-scope="scope">{{ scope.row.sessionTime }}</template>
        </el-table-column>
        <el-table-column
          label="每時段訂單數量上限"
          prop="maxNumOfOrder"
          sortable="custom"
          min-width="30px"
        >
          <template slot-scope="scope">{{ scope.row.maxNumOfOrder }}</template>
        </el-table-column>
        <el-table-column label="Actions" min-width="40px">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">編輯</div>
              <n-button
                type="primary"
                simple=""
                icon
                @click.native="edit(scope.row)"
                >
                <i class="el-icon-edit"></i>
                </n-button>
                
            </el-tooltip>
            &nbsp;
            <el-tooltip placement="top">
              <div slot="content">刪除</div>
              <n-button type="warn" 
                simple="" 
                icon
                @click.native="remove(scope.row.id) 
              ">
              <i class="el-icon-delete"></i>

              </n-button>
            </el-tooltip>
        
          </template>
        </el-table-column>
      </data-tables>
    </div>

    <!-- <n-button native-type="button" type="gray" @click.native="home()"
      >回商店列表</n-button
    > -->

    <!-- Create new order limit -->
    <el-dialog :visible.sync="dialogFormVisible" customClass="dialogWidth">
      <h5 v-if="orderLimit.id">編輯設定</h5>
      <h5 v-else>新增設定</h5>
      
      <el-row>
        <el-col :span="24">
          <h6 class="sub-title">取餐方式</h6>
        </el-col>
        <el-row>
          <el-col :span="6">
            <n-radio v-model="orderLimit.mealType" label="eat_in">內用</n-radio>
          </el-col>
          <el-col :span="6">
            <n-radio v-model="orderLimit.mealType" label="to_go">自取</n-radio>
          </el-col>
          <el-col :span="6">
            <n-radio v-model="orderLimit.mealType" label="delivery">外送</n-radio>
          </el-col>
        </el-row>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="24">
          <h6 class="sub-title">營業時間</h6>
          <span class="text-primary">{{ errors.first('periodSettings') }}</span>
        </el-col>
        <el-row>
          <el-col>
            <el-checkbox-group v-model="orderLimit.periodSession" 
              v-validate.continues="validations.periodSettings"
              name="periodSettings">
              <el-checkbox-button v-for="p in periodSettings" :key=p.value :label=p.value>{{p.label}}</el-checkbox-button>
              
            </el-checkbox-group>
          </el-col>
        </el-row>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="12">
          <h6 class="sub-title">開始時間</h6>
        </el-col>
        <el-col :span="12">
          <el-time-picker
            v-model="orderLimit.timeSessionStart"
            class="date-box"
            format='HH:mm' 
            value-format="HH:mm" 
            v-validate="validations.timeSessionStart"
            name="timeSessionStart"
            :picker-options="{
                selectableRange:`00:00:00 -${orderLimit.timeSessionEnd ? orderLimit.timeSessionEnd+':00' : '23:59:00'}`
            }">

          </el-time-picker>
        </el-col>
        <span class="text-primary">{{ errors.first('timeSessionStart') }}</span>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="12">
          <h6 class="sub-title">結束時間</h6>
        </el-col>
        <el-col :span="12">
          <el-time-picker
            v-model="orderLimit.timeSessionEnd"
            class="date-box"
            format='HH:mm' 
            value-format="HH:mm" 
            v-validate="validations.timeSessionEnd"
            name="timeSessionEnd"
            :picker-options="{
              selectableRange:`${orderLimit.timeSessionStart ? orderLimit.timeSessionStart+':00' : '00:00:00'}-23:59:00`
            }">

          </el-time-picker>
        </el-col>
        <span class="text-primary">{{ errors.first('timeSessionEnd') }}</span>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="12">
          <h6 class="sub-title">間隔時段</h6>
        </el-col>
        <el-col :span="12">
          <el-popover placement="right" trigger="click">
            <el-select
              class="select-primary"
              size="large"
              placeholder="Single Select"
              v-model="orderLimit.sessionTime"
            >
              <el-option
                v-for="(option, index) in timeSectorOptions"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="index"
              ></el-option>
            </el-select>
            <el-button size="small" slot="reference">{{orderLimit.sessionTime}}分鐘</el-button>
          </el-popover>
        </el-col>
        <span class="text-primary">{{ errors.first('sessionTime') }}</span>
      </el-row>
      <br/>
      <el-row>
        <el-col :span="12">
          <h6 class="sub-title">每時段訂單數量上限</h6>
        </el-col>
        <el-col :span="12">
          <el-input
            placeholder
            v-model="orderLimit.maxNumOfOrder"
            v-validate="validations.thNumber"
            name="thNumber"
            :key="'thNumber'"
          >
          </el-input>
        </el-col>
        <span class="text-primary">{{ errors.first('thNumber') }}</span>
 
      </el-row>
      <br />
      <span slot="footer" class="dialog-footer">
       
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="createConfirm">確定</el-button>
      </span>
    </el-dialog>
  </card>
</template>

<script>
import ElementUI from "element-ui";
import { fetchOrderLimits } from "src/javascripts/generalPages/fetchData";
import { createOrderLimit, } from "src/javascripts/generalPages/postData";
import { updateOrderLimit } from "src/javascripts/generalPages/updateData";
import { deleteOrderLimit } from "src/javascripts/generalPages/deleteData";

import { Modal } from "src/components";
import swal from "sweetalert2";
import { Collapse, CollapseItem } from "src/components";
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput,
} from "src/components/index";
import { Validator } from "vee-validate";

var accountId = "";
var type = "";
var businessId = "";
var dict = {
  custom: {
    sessionTime: {
      required: "必填",
      min_value: "填入大於0的數字",
    },
    timeSessionStart: {
      required: "必填"
    },
    timeSessionEnd: {
      required: "必填",
    },
    thNumber: {
      required: "必填",
      min_value: "填入大於0的數字",
    },
    periodSettings: {
      atLeastOne: "至少需選擇一個營業時間"
    }
  },
};

Validator.localize("en", dict);
export default {
  components: {
    Modal,
    Collapse,
    CollapseItem,
    [Switch.name]: Switch,
    [Radio.name]: Radio,
  },
  beforeRouteEnter(to, from, next) {
    console.log("this.$route: ", to);
    accountId = to.params.id;
    type = to.params.type;
    console.log("accountId: ", accountId);
    console.log("type: ", type);
    let fetchOrderLimitsData = {
      accountId: accountId,
      type: type
    };
    // next(vm => vm.setData(res.data));
    var data = {};

    fetchOrderLimits(fetchOrderLimitsData)
      .then((res) => {
        console.log("fetchOrderLimits: ", res);
        next((vm) => vm.setData(res.data));
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      timeSectorOptions: [{
        value: '15',
        label: '15分鐘'
      }, {
        value: '30',
        label: '30分鐘'
      }, {
        value: '60',
        label: '60分鐘'
      }],
      accountId: this.$route.params.id,
      portalType: this.$route.params.type,
      tableData: [],
      filters: [
        {
          prop: ["mealType"],
          value: "",
        },
      ],
      tableProps: {
        // defaultSort: {
        //   prop: "mealType",
        //   order: "descending",
        // },
      },
      periodSettings: [{
        label: "週日",
        value: 0,
      },{
        label: "週一",
        value: 1,
       },{
        label: "週二",
        value: 2,
      },{
        label: "週三",
        value: 3,
      },{
        label: "週四",
        value: 4,
      },{
        label: "週五",
        value: 5,
      },{
        label: "週六",
        value: 6,
      }],
      defaultOrderLimit: {
        mealType: "eat_in",
        periodSession: [0,1,2,3,4,5,6],
        timeSessionStart: "12:00", 
        timeSessionEnd: "18:00",
        sessionTime: 30,
        maxNumOfOrder: 5
      },
      orderLimit: {},
      dialogFormVisible: false,
      validations: {
        sessionTime: {
          required: true,
          min_value: 0,
        },
        timeSessionStart: {
          required: true
        },
        timeSessionEnd: {
          required: true
        },
        thNumber: {
          required: true,
          min_value: 0,
        }, 
        periodSettings: {
          atLeastOne: true
        }
      }
    };
  },
  created () {
    this.$validator.extend('atLeastOne', {
      getMessage () {
        return `At least one item must be selected.`;
      },
      validate: () => {
        return this.orderLimit.periodSession.length>0;
      }
    })
  },
  methods: {
    setData(data) {
      console.log('set data', data);
      this.tableData = data.map((d, index) => {
        return Object.assign(
          {},
          {
            index: index,
            id: d.id,
            accountId: accountId,
            mealType: d.mealType,
            periodSession: d.periodSession,
            timeSessionStart: d.timeSession.start,
            timeSessionEnd: d.timeSession.end,
            sessionTime: d.sessionTime,
            maxNumOfOrder: d.maxNumOfOrder
          }
        );
      });
      console.log(this.tableData);
    },
    edit(row) {
      console.log("edit", row);
      this.orderLimit = Object.assign(
        {}, row
      );
      this.dialogFormVisible = true;
    },
    add() {
      console.log("add");
      this.orderLimit = Object.assign(
        {}, this.defaultOrderLimit
      );
      this.dialogFormVisible = true;
    },

    // home: function () {
    //   window.history.back();
    // },

    createConfirm() {
      this.$validator.validateAll().then((valid) => {
        console.log("valid: ", valid);
        if (valid) {
          let orderLimitData = { 
            mealType: this.orderLimit.mealType,
            periodSession: this.orderLimit.periodSession,
            timeSession: {
              start: this.orderLimit.timeSessionStart,
              end: this.orderLimit.timeSessionEnd
            },
            sessionTime: this.orderLimit.sessionTime,
            maxNumOfOrder: this.orderLimit.maxNumOfOrder
          }
          
          if (this.orderLimit.id) {
            // update current setting
            let id = this.orderLimit.id;
            updateOrderLimit(this.portalType, this.accountId, id, orderLimitData)
              .then(res => {
                console.log("updateOrderLimit: ", res.data);
                this.$message({
                  type: "success",
                  message: "編輯成功"
                });
                
                let fetchOrderLimitsData = {
                  accountId: this.accountId,
                  type: this.portalType,
                };
                fetchOrderLimits(fetchOrderLimitsData)
                .then((res) => {
                  this.setData(res.data);
                  //this.dialogFormVisible = false;
                })
                .catch((err) => {
                  console.log("err: ", err);
                })
                .finally(()=>{
                  this.dialogFormVisible = false;
                });
                //this.dialogFormVisible = false;
              })
              .catch(err => {
                console.log("err: ", err);
                this.$message({
                  type: "error",
                  message: err.message
                });
              });
          }else{
            // add new 
          
            console.log("createOrderLimit: ", orderLimitData);
            createOrderLimit(this.portalType, this.accountId, orderLimitData)
              .then(res => {
                console.log("createOrderLimitRes: ", res.data);
                this.$message({
                  type: "success",
                  message: "新增成功"
                });
                let newOrderLimit = Object.assign(
                  {}, this.orderLimit
                );
                newOrderLimit.id = res.data.insertId;
                
                this.tableData.push(newOrderLimit);
                this.dialogFormVisible = false;
              })
              .catch(err => {
                console.log("err: ", err);
                this.$message({
                  type: "error",
                  message: err.message
                });
              });
          }
        }
      });
    },
    remove(id) {
      swal.fire({
        title: `確定要刪除限流設定嗎？`,
        buttonsStyling: true,
        // confirmButtonClass: "btn btn-success btn-fill",
        showCancelButton: true,
        confirmButtonColor: "#f96332",
        cancelButtonColor: "#cccccc",
        confirmButtonText: "刪除",
      }).then((res) => {
        console.log("res: ", res);
        if (res.value) {
          let data = {
            id,
            accountId,
            type: this.portalType
          };
          deleteOrderLimit(data)
            .then((deleteOrderLimitRes) => {
              let _index = this.tableData.findIndex((d) => d.id == id);
              this.tableData.splice(_index, 1);
              this.$message({
                type: "success",
                message: "刪除成功！",
              });
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err.message,
              });
            });
        }
      });
    },
    
  },
  
  // updated: function() {

  // }
};
</script>

<style>
  /* .dialogWidth{
    width:50%;
  } */
  /* For Mobile */
@media screen and (max-width: 540px) {
    .dialogWidth {
        width: 95%;
    }
}

/* For Tablets */
@media screen and (min-width: 540px) and (max-width: 780px) {
    .dialogWidth {
        width: 80%;
    }
}

/* For Tablets */
@media screen and (min-width: 780px) {
    .dialogWidth {
        width: 580px;
    }
}

</style>
